<template>
  <div class="invoices">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <InvoicesTable
      :isReadOnly="isReadOnly"
      @create-invoice="onCreateInvoice"
      @edit-invoice="onEditInvoice"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import InvoicesTable from '@/components/Invoices/InvoicesTable';
import { mapGetters } from 'vuex';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { INVOICES_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'Invoices',
  components: {
    Breadcrumbs,
    InvoicesTable,
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(INVOICES_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('invoices') }];
    },
  },
  methods: {
    onCreateInvoice() {
      this.$router.push({ name: 'InvoiceCreatePage' });
    },
    onEditInvoice(invoice) {
      this.$router.push({
        name: 'InvoiceEditPage',
        params: { invoiceNumber: invoice.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
